import { ESTIMATED_WEIGHT_LOSS_PERCENTAGE_BY_WEEK } from "../../constants";

/**
 *
 * @param {number} initialWeight
 * @returns  {Array<{week: number, weight: number}>}
 */
export const getEstimatedWeightLossData = initialWeight =>
  ESTIMATED_WEIGHT_LOSS_PERCENTAGE_BY_WEEK.map(
    ([week, estimatedPercentage]) => ({
      week,
      weight: initialWeight * (1 - estimatedPercentage)
    })
  );

/**
 * @param {number} initialWeightLb
 * @returns {number}
 */
export function getEstimatedFinalWeight(initialWeightLb) {
  const finalPercentage =
    ESTIMATED_WEIGHT_LOSS_PERCENTAGE_BY_WEEK[
      ESTIMATED_WEIGHT_LOSS_PERCENTAGE_BY_WEEK.length - 1
    ][1];

  return Math.floor(initialWeightLb * (1 - finalPercentage));
}
